(function($) {

    'use strict';

    if(typeof JQM === 'undefined') {
        return null;
    }

    /**
     * main menu module
     *
     * @class JQM.MainMenu
     */
    var MainMenu = (function() {

        /**
         * Reference on the container
         *
         * @private
         * @property container
         * @type {Object}
         */
        var container = '.menu--main',

        /** Reference on the body for toggle css class
         *
         * @private
         * @property body
         * @type {Object}
         */
            body = $('body'),

        /**
         * Reference on the nav-button
         *
         * @private
         * @property navBtn
         * @type {Object}
         */
            navBtn = $('#pushmenu-button'),

        /**
         * CSS class for menu items if there is open
         *
         * @private
         * @property menuActiveClass
         * @type {String}
         */
            menuActiveClass = 'menu-is-active';

        /**
         * Initialization of the module
         *
         * @method init
         */
        function init() {
            container = $(container);

            if ( container.length ) {
                initListener();
            }
        }

        /**
         * Register Listener
         *
         * @private
         * @method initListener
         */
        function initListener() {
            toggleNavigation();

           // close navigation on resize, recalculate submenus height
            $(window).on('resize', function() {
                closeNavigation();
                toggleNavigation();
            });


        }

        function toggleNavigation() {
            $(navBtn).off('click');

            $(navBtn).on('click', function() {
                body.toggleClass(menuActiveClass);
            });
        }

        function closeNavigation() {
            body.removeClass(menuActiveClass);
        }


        /**
         * @return Public-API
         */
        return {
            init: init
        };

    }());


    JQM.MainMenu = MainMenu;

    return MainMenu;

}(jQuery));
